import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-800 via-blue-700 to-blue-500 text-center relative overflow-hidden px-4">
      {/* Background Glow */}
      <motion.div
        className="absolute w-[400px] h-[400px] bg-yellow-400 rounded-full blur-3xl opacity-20 top-10 left-10"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2 }}
      />
      <motion.div
        className="absolute w-[400px] h-[400px] bg-blue-300 rounded-full blur-3xl opacity-25 bottom-10 right-10"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5 }}
      />

      {/* Title */}
      <motion.h1
        className="text-4xl md:text-5xl lg:text-6xl font-bold text-yellow-300 tracking-wide mb-8 drop-shadow-[0_3px_3px_rgba(0,0,0,0.3)]"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Your Learning Vibes
	  </motion.h1>
	  
	   {/* Title */}
      <motion.h2
        className="text-4xl md:text-5xl lg:text-2xl text-yellow-300 tracking-wide mb-8 drop-shadow-[0_3px_3px_rgba(0,0,0,0.3)]"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
		Known your vibe, level up your learn
      </motion.h2>

      {/* Static Image */}
      <motion.img
        src="/images/Capture1.png"
        alt="Learning Vibes Illustration"
        className="w-[260px] sm:w-[320px] md:w-[420px] lg:w-[500px] drop-shadow-2xl mb-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />

      {/* LET’S VIBES Button */}
      <motion.button
        whileHover={{
          scale: 1.08,
          boxShadow: "0px 0px 25px rgba(255, 255, 0, 0.5)",
        }}
        whileTap={{ scale: 0.96 }}
        onClick={() => navigate("/login")}
        className="bg-yellow-400 hover:bg-yellow-300 text-blue-800 text-2xl md:text-3xl font-bold px-12 py-4 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300"
      >
        Let’s Vibes
      </motion.button>

      {/* Footer */}
      <div className="mt-16 flex flex-col items-center gap-2">
        {/* Tambahan logo UT di atas tulisan */}
        <motion.img
          src="/images/logo-ut.png"
          alt="Logo Universitas Terbuka"
          className="w-16 md:w-20 opacity-90 mb-2"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
        />
        <motion.p
          className="text-xs sm:text-sm md:text-base text-gray-100 tracking-widest uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          UNIVERSITAS TERBUKA
        </motion.p>
      </div>
    </div>
  );
};

export default LandingPage;
